import { DayDetailRequest } from './ReportingPage';
import DayTimeline from '../shared/DayTimeline';
import { requestOnDay } from '../shared/dayTimelineUtils';

const TimelineView = ({
  dayDetailRequests,
  day,
}: {
  dayDetailRequests: DayDetailRequest[];
  day?: Date;
}) => {
  const timelineDay = day ?? new Date(dayDetailRequests[0]?.startDateTime ?? Date.now());
  const requestsForDay = dayDetailRequests.filter((request) => requestOnDay(request, timelineDay));

  return (
    <DayTimeline
      day={timelineDay}
      requests={requestsForDay}
      interactive={false}
      title="After Hours Requests Timeline"
    />
  );
};

export default TimelineView;
